import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './plugins/axios'
Vue.config.productionTip = false
import { Col, Row } from 'vant';

Vue.use(Col);
Vue.use(Row);

Vue.prototype.axios = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
